import { els } from "./dom";

/**
 * Check authentication status and display login modal if needed.
 */
export async function checkAuth(): Promise<boolean> {
  try {
    const response = await fetch("/auth/status");
    const data = await response.json();

    if (data.isAuthenticated) {
      if (els.loginModal) {
        els.loginModal.classList.add("hidden");
      }
      return true;
    } else {
      if (els.loginModal) {
        els.loginModal.classList.remove("hidden");
      }
      return false;
    }
  } catch (err) {
    console.error("Auth check failed:", err);
    if (els.loginModal) {
      els.loginModal.classList.remove("hidden");
    }
    return false;
  }
}

/**
 * Bind login button events.
 */
export function bindLoginModal(): void {
  if (!els.loginBtn) return;

  els.loginBtn.addEventListener("click", () => {
    if (els.authLoading) {
      els.authLoading.classList.remove("hidden");
    }
    if (els.authError) {
      els.authError.classList.add("hidden");
    }
    window.location.href = "/auth/google/start";
  });
}

/**
 * Handle auth callback from URL params (auth=success/error).
 */
export function handleAuthCallback(): void {
  const params = new URLSearchParams(window.location.search);
  const authStatus = params.get("auth");
  const authMessage = params.get("message");

  if (authStatus === "success") {
    if (els.authLoading) {
      els.authLoading.classList.add("hidden");
    }
    if (els.loginModal) {
      els.loginModal.classList.add("hidden");
    }
    window.history.replaceState({}, document.title, "/");
  } else if (authStatus === "error") {
    console.error("Authentication failed:", authMessage);
    if (els.authLoading) {
      els.authLoading.classList.add("hidden");
    }
    if (els.authError) {
      els.authError.textContent = `Error: ${authMessage || "Unknown error"}`;
      els.authError.classList.remove("hidden");
    }
  }
}

/**
 * Bind logout button events.
 */
export function bindLogout(): void {
  if (!els.logoutBtn) return;

  els.logoutBtn.addEventListener("click", async () => {
    if (!confirm("Are you sure you want to sign out?")) {
      return;
    }

    try {
      const response = await fetch("/auth/google/logout");
      if (response.ok) {
        window.location.href = "/";
      } else {
        alert("Logout failed. Please try again.");
      }
    } catch (err) {
      console.error("Logout error:", err);
      alert("Logout failed. Please try again.");
    }
  });
}
